import { mapGetters, mapActions } from 'vuex'
import ucarStorage from './utils/storage'
import { transformImgUrl } from './utils/transform'
import { loginStatus, PhotoBaseData, PhotoTypeMap } from './utils/constants'
import thirdLib from './utils/thirdlib'
import { submitRegInfo, reSubmitRegInfo } from './api'
// 报名流程全局状态mixin
export const vuexMixin = {
  computed: {
    ...mapGetters([
      'vuexCrimeRejectReason',
      'vuexNewRecruit',
      'vuexOwnCarJoin',
      'vuexDriverType',
      'vuexDriverInfo',
      'vuexVehicleInfo',
      'vuexIndexUrl',
      'vuexLoginType',
      'vuexRegType',
      'vuexRecruitStatus',
      'vuexJoinMode',
      'vuexRecruitId',
      'vuexPersonMobile',
      'vuexPersonInfo',
      'vuexCarInfo',
      'vuexTeamInfo',
      'vuexSubmitInfo',
      'vuexChannelType',
      'vuexCompanyId',
      'vuexCompanyName',
      'vuexInviteCode',
      'vuexWxQuery',
      'vuexServiceCities',
      'vuexCurrentCity',
      'vuexDisapproveInfo',
      'vuexModifyInfo',
      'vuexRentData',
      'vuexSaleData',
      'vuexCachedInfo',
      'vuexFrom'
    ])
  },
  methods: {
    ...mapActions([
      'setVuexCrimeRejectReason',
      'setVuexNewRecruit',
      'setVuexOwnCarJoin',
      'setVuexDriverType',
      'setVuexDriverInfo',
      'setVuexVehicleInfo',
      'setVuexIndexUrl',
      'setVuexLoginType',
      'setVuexRegType',
      'setVuexRecruitStatus',
      'setVuexRecruitId',
      'setVuexPersonMobile',
      'setVuexPersonInfo',
      'setVuexCarInfo',
      'setVuexTeamInfo',
      'setVuexSubmitInfo',
      'setVuexChannelType',
      'setVuexCompanyId',
      'setVuexCompanyName',
      'setVuexInviteCode',
      'setVuexWxQuery',
      'setVuexServiceCities',
      'setVuexCurrentCity',
      'setVuexDisapproveInfo',
      'setVuexModifyInfo',
      'resetInfo',
      'resetRecommendInfo',
      'setVuexCachedInfo',
      'setVuexFrom'
    ]),
    findCachedInfo () {
      return this.vuexCachedInfo.find((item) => {
        return item && item.mobile === this.vuexPersonMobile
      })
    },
    cacheInfoForLongTime (type, data) {
      if (type !== 'person' && type !== 'car' && type !== 'team') return
      const result = this.vuexCachedInfo.find((item) => {
        return item && item.mobile === this.vuexPersonMobile
      })
      const body = {
        ...result,
        mobile: this.vuexPersonMobile
      }
      body[`${type}Info`] = data
      this.setVuexCachedInfo(body)
    },
    handleStatusChange (res) {
      if (res.isSuccess || res.failureCode === 41) {
        this.resetRecommendInfo()
        this.changeStatusToReviewInfo()
        this.$router.push(`/enroll-result?id=${res.id}`)
      }
      const msg = res.failureMess || res.failMess
      if (msg) this.$alert(msg)
    },
    finalSubmit () {
      let body = {
        ...this.vuexSubmitInfo,
        channelType: this.vuexChannelType ? Number(this.vuexChannelType) : 0
      }
      if (this.vuexRegType === '4' || this.vuexRegType === '5') {
        body.companyId = this.vuexCompanyId
      }
      if (this.vuexInviteCode) {
        body.inviteCode = this.vuexInviteCode
      }
      if (this.vuexWxQuery) {
        body = { ...body, ...this.vuexWxQuery }
      }
      return submitRegInfo(body)
    }
  }
}
// 培训全局变量
export const trainMixin = {
  computed: {
    ...mapGetters([
      'vuexTrainExamData',
      'vuexTrainConfig',
      'vuexTrainExamResult'
    ])
  },
  methods: {
    ...mapActions([
      'setVuexTrainExamData',
      'setVuexTrainConfig',
      'setVuexTrainExamResult'
    ])
  }
}
// 修改信息mixin
export const modifyMixin = {
  computed: {
    ...mapGetters([
      'vuexRecruitId',
      'vuexDisapproveInfo',
      'vuexModifyInfo'
    ])
  },
  methods: {
    ...mapActions([
      'setVuexModifyInfo'
    ]),
    modifyInit () {
      if (this.$route.query.mode === 'modify') {
        this.mode = this.$route.query.mode
        const { baseInfo, photoInfo } = this.vuexDisapproveInfo
        const info = this.$route.name === 'person-info' ? baseInfo.personInfo : baseInfo.carInfo
        this.info = info
        for (let key in photoInfo) {
          if (!this.photoInfo.hasOwnProperty(PhotoTypeMap[key])) continue
          this.photoInfo[PhotoTypeMap[key]] = photoInfo[key].imgUrl
        }
      }
    },
    submitModify () {
      const { needModify } = this.vuexDisapproveInfo
      const body = {
        id: this.vuexRecruitId
      }
      let infoTest = true
      needModify.forEach(item => {
        console.log(item,PhotoBaseData[PhotoTypeMap[item]].modifyKey)
        if (!this.photoInfo.hasOwnProperty(PhotoTypeMap[item])) return
        if (this.vuexDisapproveInfo.photoInfo[item].imgUrl === this.photoInfo[PhotoTypeMap[item]]) {
          infoTest = false
          return
        }
        body[PhotoBaseData[PhotoTypeMap[item]].modifyKey] = this.photoInfo[PhotoTypeMap[item]]
      })
      if (!infoTest) {
        this.$alert('请按示例要求重新上传需要修改的照片')
        return
      }
      this.setVuexModifyInfo(transformImgUrl({
        ...this.vuexModifyInfo,
        ...this.vuexRecruitStatus,
        ...body
      }))
      if (this.vuexDisapproveInfo.errorType === 3 && this.$route.name === 'person-info') {
        this.$router.push('/car-info?mode=modify')
      } else {
        reSubmitRegInfo({
          ...this.vuexModifyInfo,
          recruitType: this.vuexRegType
        }).then(res => {
          if (res.isSuccess || res.failureCode === 41) {
            this.changeStatusToReviewInfo()
            this.$router.push(`/enroll-result?id=${res.id}`)
          }
          if (res.failureMess) this.$alert(res.failureMess)
        })
      }
    }
  }
}
// 登录状态改变mixin
export const loginStatusMixin = {
  methods: {
    changeStatusToFillInfo () {
      ucarStorage.setSession('ucar-login-status', loginStatus.fillInfo)
    },
    changeStatusToReviewInfo () {
      ucarStorage.setSession('ucar-login-status', loginStatus.reviewInfo)
    },
    changeStatusToModifyInfo () {
      ucarStorage.setSession('ucar-login-status', loginStatus.modifyInfo)
    },
    changeStatusToTeamReviewInfo () {
      ucarStorage.setSession('ucar-login-status', loginStatus.teamReviewInfo)
    },
    changeStatusToTeamActivated () {
      ucarStorage.setSession('ucar-login-status', loginStatus.teamActivated)
    },
    resetLoginStatus () {
      ucarStorage.removeSession('ucar-login-status')
      ucarStorage.removeStorage('carInfo')
      ucarStorage.removeStorage('carPhotoInfo')
      ucarStorage.removeStorage('routeTo')
      ucarStorage.removeStorage('mobile')
      ucarStorage.removeStorage('recruitId')
      ucarStorage.removeStorage('idCard')
      ucarStorage.removeStorage('photoInfo')
    }
  }
}
// 登录状态重置mixin
export const resetLoginStatusMixin = {
  data () {
    return {
      loginStatus: ucarStorage.getSession('ucar-login-status')
    }
  },
  methods: {
    logout () {
      ucarStorage.removeSession('ucar-login-status')
    }
  }
}

export const titleMixin = {
  data () {
    return {
      title: '神州专车司机招募'
    }
  },
  methods: {
    setTitle (val) {
      setTimeout(() => {
        document.title = val
        document.getElementsByTagName('title').innerText = val
      })
    }
  },
  mounted () {
  }
}

export const hmMixin = {
  methods: {
    trackEvent () {
      return thirdLib.trackEvent(...arguments)
    }
  }
}
